import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import { ButtonLanding, InputMain, MaskInputMain } from 'components';
import { authService } from 'store';

export const GetInTouch = () => {
    const [notRobot, toggleNotRobotCheckbox] = useState(false);
    const [loading, setLoading] = useState(false);
    const recaptchaRef = useRef(null);
    const { register, handleSubmit, control, reset } = useForm();

    const onSubmit = async (data) => {
        const onlyNumbers = data?.phone.replace(/\D/g, '');

        const sendData = {
            fullName: data?.fullName,
            email: data?.email,
            message: data?.message,
            phone: onlyNumbers,
            companyName: data?.companyName,
        };

        setLoading(true);
        try {
            if (notRobot) {
                await authService.mailer(sendData);
            }
            reset({
                fullName: '',
                email: '',
                phone: '',
                companyName: '',
                message: '',
            });
            toast.success('Message was sent', {
                position: 'bottom-right',
            });
        } catch (e) {
            toast.error('Something went wrong', {
                position: 'bottom-right',
            });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    function onChange(val) {
        toggleNotRobotCheckbox(val);
    }

    return (
        <div className="get-in-touch-wrapper" style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="get-in-touch-block">
                <p className="were-here-for-you">We’re Here for You</p>
                <p className="were-here-for-you-desc">Have a question? Reach out anytime — we’d love to hear from you.</p>
                <form onSubmit={handleSubmit(onSubmit)} className="inputs-form">
                    <div className="inputs-form-display-flex">
                        <InputMain
                            {...register('fullName', { required: 'This Field is required' })}
                            control={control}
                            placeholder="Your name"
                            labelHeader="Full Name*"
                            variant="outlined"
                        />
                        <InputMain
                            {...register('email', { required: 'This Field is required' })}
                            control={control}
                            placeholder="you@company.com"
                            type="email"
                            classNameWrapper="margin-bottom"
                            required
                            labelHeader="Email*"
                            variant="outlined"
                        />
                    </div>

                    <div className="inputs-form-display-flex">
                        <MaskInputMain
                            {...register('phone', { required: 'This Field is required' })}
                            control={control}
                            placeholder="(555) 000-0000"
                            classNameWrapper="margin-bottom"
                            type="number"
                            labelHeader="Phone Number*"
                            variant="outlined"
                        />
                        <InputMain
                            {...register('companyName', { required: 'This Field is required' })}
                            control={control}
                            placeholder="Eachbase"
                            classNameWrapper="margin-bottom"
                            labelHeader="Company Name*"
                            variant="outlined"
                        />
                    </div>

                    <div className="">
                        <p className="input-main-label-header">Your Message*</p>

                        <textarea
                            style={{ resize: 'none', padding: '10px', fontSize: 16, height: 130, width: '100%' }}
                            className="textarea-form-control"
                            rows={6}
                            placeholder="Your Message"
                            {...register('message', { required: 'This Field is required' })}
                        />
                    </div>

                    {/*<InputMain*/}
                    {/*    {...register('message', { required: 'This Field is required' })}*/}
                    {/*    control={control}*/}
                    {/*    placeholder="Your Message*"*/}
                    {/*    classNameWrapper="margin-bottom fullWidth"*/}
                    {/*/>*/}

                    <div className="checkbox-button-box">
                        <div className="checkboxes-wrapper" style={{ margin: '12px 0' }}>
                            <ReCAPTCHA ref={recaptchaRef} sitekey={'6Leq6wAqAAAAABQhutLaoN5Sw0etRUz_ex7yLwEg'} onChange={onChange} />
                        </div>

                        <ButtonLanding
                            disabled={!notRobot}
                            load={loading}
                            circleSize={35}
                            loadingColor="#FFF"
                            arrowIcon={true}
                            text="Send Message"
                            className="send-button"
                            type="submit"
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};
